import React from 'react'
import {Icon} from '@chakra-ui/react'

const GalleryBucketProductIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <path
                d="M8.16699 12.8334V7.00002C8.16699 6.6906 8.04408 6.39386 7.82528 6.17506C7.60649 5.95627 7.30975 5.83335 7.00033 5.83335H2.33366C2.02424 5.83335 1.72749 5.71044 1.5087 5.49164C1.28991 5.27285 1.16699 4.97611 1.16699 4.66669V2.33335C1.16699 2.02393 1.28991 1.72719 1.5087 1.5084C1.72749 1.2896 2.02424 1.16669 2.33366 1.16669H11.667C11.9764 1.16669 12.2732 1.2896 12.492 1.5084C12.7107 1.72719 12.8337 2.02393 12.8337 2.33335V12.8334H1.16699"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.8338 5.83331L5.13379 5.83331"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 12.8334V9.33335C10.5 9.02393 10.6229 8.72719 10.8417 8.5084C11.0605 8.2896 11.3572 8.16669 11.6667 8.16669H12.8333"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.08301 5.83331V6.99998"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.08301 12.8333C3.09134 12.8333 2.33301 12.075 2.33301 11.0833V9.33331H5.83301V11.0833C5.83301 12.075 5.07467 12.8333 4.08301 12.8333Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.16699 10.5C1.16699 10.1906 1.28991 9.89381 1.5087 9.67502C1.72749 9.45623 2.02424 9.33331 2.33366 9.33331"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                opacity="0.1"
                x1="10.2496"
                y1="12.6"
                x2="10.2496"
                y2="1.39998"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <path
                opacity="0.1"
                d="M7.17481 6.29999L7.1748 1.39999"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <path
                opacity="0.1"
                d="M4.2002 5.59998L4.2002 1.39998"
                stroke="currentColor"
                strokeWidth="1.2"
            />
        </Icon>
    )
}

export default GalleryBucketProductIcon
